import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  listPanel: {
    boxShadow: tokens.shadow4,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    backgroundColor: tokens.colorNeutralBackground1,
    '& .card-header': {
      ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
      '& svg:first-child': {
        width: '24px',
        height: '24px',
      },
    },
    '& .card-title': {
      ...typographyStyles.subtitle2,
    },
    '& .list-body-header': {
      ...shorthands.margin('12px', 0),
    },
  },
  addBtn: {
    width: '94px',
    height: '94px',
    maxWidth: '94px',
    maxHeight: '94px',
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.border(tokens.strokeWidthThin, 'dashed', '#C8C6C4'),
  },
  actionBtns: {
    display: 'flex',
    position: 'absolute',
    ...shorthands.gap('8px'),
    bottom: '10px',
    left: '50%',
    transform: 'translate(-50%, 0)',
    '& button': {
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
      backgroundColor: tokens.colorNeutralBackground1,
      ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke1),
    },
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap('8px'),
    '& .list-image': {
      width: 'auto',
      position: 'relative',
      ...shorthands.borderRadius(tokens.borderRadiusLarge),
      boxShadow: tokens.shadow4,
      '& img': {
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        height: '94px',
      },
    },
  },
});


export const getSkeletonStyles = makeStyles({
  row: {
    display: 'flex',
    ...shorthands.gap('8px'),
    flexWrap: 'wrap',
  },
  item: {
    height: '94px',
    width: '94px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
});
